/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationSettings
 */
export interface IntegrationSettings {
    /**
     * 
     */
    max_document_age_days: number;
    /**
     * 
     */
    cprm_ignore_latest_document_date: boolean;
    /**
     * 
     */
    aida_download_joined_records?: boolean;
}

/**
 * Check if a given object implements the IntegrationSettings interface.
 */
export function instanceOfIntegrationSettings(value: object): value is IntegrationSettings {
    if (!('max_document_age_days' in value) || value['max_document_age_days'] === undefined) return false;
    if (!('cprm_ignore_latest_document_date' in value) || value['cprm_ignore_latest_document_date'] === undefined) return false;
    return true;
}

export function IntegrationSettingsFromJSON(json: any): IntegrationSettings {
    return IntegrationSettingsFromJSONTyped(json, false);
}

export function IntegrationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'max_document_age_days': json['max_document_age_days'],
        'cprm_ignore_latest_document_date': json['cprm_ignore_latest_document_date'],
        'aida_download_joined_records': json['aida_download_joined_records'] == null ? undefined : json['aida_download_joined_records'],
    };
}

export function IntegrationSettingsToJSON(json: any): IntegrationSettings {
    return IntegrationSettingsToJSONTyped(json, false);
}

export function IntegrationSettingsToJSONTyped(value?: IntegrationSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max_document_age_days': value['max_document_age_days'],
        'cprm_ignore_latest_document_date': value['cprm_ignore_latest_document_date'],
        'aida_download_joined_records': value['aida_download_joined_records'],
    };
}

